import { useLocalStorage } from '@rehooks/local-storage';
import _ from 'lodash';
import { REFERRALS } from '../types';

type ReferralsStorage = {
  viewedReferralCodes: string[];
};

export const useNewReferrals = () => {
  const [referralsStorage, setReferralsStorage] = useLocalStorage<ReferralsStorage>('Referrals', {
    viewedReferralCodes: [],
  });
  return {
    newReferrals: REFERRALS.filter((x) => !referralsStorage.viewedReferralCodes.includes(x.code)),
    setViewedReferrals: (referralCodes: string[]) => {
      const newValue = _.uniq([...referralsStorage.viewedReferralCodes, ...referralCodes]);
      if (_.isEqual(newValue, referralsStorage.viewedReferralCodes)) return;
      setReferralsStorage({
        viewedReferralCodes: newValue,
      });
    },
  };
};
